module.exports = __webpack_public_path__ + "img/SET MORENA ISLA.03f19c79.jpg";